module.exports = __webpack_public_path__ + "img/anclivepa_publico.8e58f9d1.jpeg";